/// <amd-module name="VSS/Features/Markdown/Plugins/MarkdownLinesMapping" />
import * as MarkdownIt from "markdown-it";
import { MarkdownConstants } from "VSS/Features/Markdown/MarkdownConstants";
import { IState } from "VSS/Features/Markdown/MarkdownIt";
import { LineAttrInfoMap } from "VSS/Features/Markdown/MarkdownRendererContracts";

/**
 * This plugin add the attributes to each markdown html
 * generated tags to have the mardown line number map
 */
export class MarkdownLinesMapping {
    constructor(md: MarkdownIt.MarkdownIt, onLinesMappingComplete?: (mapping: LineAttrInfoMap) => void) {
        md.core.ruler.push("markdown_map_line_numbers", state => this._processLineNumberMapping(state, onLinesMappingComplete));
    }

    // Add the line mapping attribute to the token and add in lineAttrInfoMap
    private _addLineAttrToTokenAndInfoMap = (
        token: MarkdownIt.Token,
        map: number[],
        counter: number,
        markup: string,
        lineAttrInfoMap: LineAttrInfoMap,
        addLineAttrInfoToMap: boolean
    ): void => {
        const attrValue = counter + "";
        token.attrPush([MarkdownConstants.MarkDownLinesMappingAttrName, attrValue]);
        if (addLineAttrInfoToMap) {
            lineAttrInfoMap[attrValue] = {
                startLine: map[0],
                endLine: map[1],
                isBlock: token.block,
                markup: markup
            };
        }
    };

    private _processLineNumberMapping = (state: IState, onLinesMappingComplete?: (mapping: LineAttrInfoMap) => void): void => {
        const lineAttrInfoMap: LineAttrInfoMap = {};
        let counter = 1;
        const isCallBackPresent = !!onLinesMappingComplete;
        state.tokens.forEach(token => {
            if (token.map !== null) {
                if (token.type !== "inline") {
                    this._addLineAttrToTokenAndInfoMap(token, token.map, counter, "", lineAttrInfoMap, isCallBackPresent);
                    counter++;
                } else {
                    token.children.forEach(child => {
                        if (child.markup != "" && !child.type.endsWith("close")) {
                            this._addLineAttrToTokenAndInfoMap(child, token.map, counter, child.markup, lineAttrInfoMap, isCallBackPresent);
                            counter++;
                        }
                    });
                }
            }
        });
        if (onLinesMappingComplete) {
            onLinesMappingComplete(lineAttrInfoMap);
        }
    };
}
